import { useEffect, useState } from "react";
import Player from "./RoosterPlayer";
import image from "../../../images/common/HeadSilhouette.png";
import styled from "styled-components";
import EmptyPlayer from "./EmptyPlayer";
import { useLeague } from "../../../context/useLeague";
import { useUser } from "../../../context/useUser";
import { positions } from "../../../content-options/positions/userPositions";

const EmptyRooster = ({}) => {
  const { league } = useLeague();
  const { user } = useUser();

  // The users team
  const [team, setTeam] = useState("");
  // the users rooster
  const [rooster, setRooster] = useState("");
  // The users leagues
  const [leagues, setLeagues] = useState("");
  // is the user a manager?
  const [manager, setManager] = useState(false);

  useEffect(() => {
    if (league && user) {
      if (!user || !league) {
        console.log("error: no user/leagues");
        return;
      }
    }
    if (league.status === "building") {
      if (league.registered) {
        setRegistered(true);
      }
      const usersTeam = league;
      setTeam(usersTeam);
      setRooster(usersTeam.rooster);
      if (usersTeam && usersTeam.managerId && user.id === usersTeam.managerId) {
        console.log(usersTeam.rooster.map((player) => player.id));
        setManager(true);
      }
    }
  }, [league]);

  // get from back end
  const [registered, setRegistered] = useState(false);
  // const [manager, setManager] = useState(false);

  const [players, setPlayers] = useState([
    "Aldo",
    "Andy",
    "Brynjar",
    "Callum",
    "Colin",
    "Dave",
    "James",
  ]);

  const handleClickRegister = () => {
    if (registered) {
      alert(
        "You're team is successfully registered.  You will be asigned to a league by one of our admins as soon as one becomes available."
      );
    } else if (rooster && rooster.length < 6) {
      alert("You need at least 7 players to register for a league.");
    } else if (!manager) {
      alert("Sorry! Only the manager can register for a league.");
    } else {
      // TODO : register this team
      alert(
        "You're team is successfully registered.  You will be asigned to a league by one of our admins as soon as one becomes available."
      );
      // insert cloud function
      // setRegistered(true);
    }
  };

  return (
    <>
      <>
        <div className="container mb-3 mt-2 pb-4">
          {/* information */}
          <div className="row d-flex justify-content-center align-items-center text-center px-4">
            <p style={{ maxWidth: "450px" }}>
              A minimum of 7 players are required to register for a league. Once
              Registered, you will be asigned to a league by one of our admins.
            </p>
          </div>
          {/* players in roster */}
          <GridContainer className="row">
            {rooster && rooster.length
              ? [...Array(24).fill(0)].map((x, i) =>
                  rooster.sort(
                    (player1, player2) =>
                      positions.indexOf(player1.position) -
                      positions.indexOf(player2.position)
                  )[i] ? (
                    <div className="col-lg-2 col-md-3 col-4" key={i}>
                      <Player
                        name={rooster[i].name}
                        image={image}
                        position={rooster[i].position}
                      />
                    </div>
                  ) : (
                    <div className="col-lg-2 col-md-3 col-4" key={i}>
                      <EmptyPlayer />
                    </div>
                  )
                )
              : null}
          </GridContainer>
          {/* Register button */}
          <div className="row d-flex justify-content-center align-items-center text-center flex-column">
            <RegisterContainer>
              <RegisterText>
                Remaining players required to register for a league
                <Bold>{7 - players.length > 0 ? 7 - players.length : 0}</Bold>
              </RegisterText>
              <Button
                onClick={handleClickRegister}
                className={`btn btn-sm 
                ${
                  registered
                    ? "btn-success"
                    : players.length >= 7
                    ? "btn-primary"
                    : "btn-secondary"
                }`}
              >
                {registered ? "Registered" : "Register"}
              </Button>
            </RegisterContainer>
            {registered ? (
              <div className="px-5" style={{ maxWidth: "500px" }}>
                Your team is successfully registered. Our admins will asign you
                to a league as soon as one becomes available.
              </div>
            ) : null}
          </div>
        </div>
      </>
    </>
  );
};
export default EmptyRooster;

const GridContainer = styled.div`

  @media (max-width: 575px) {
    padding: 0 1rem;
  }
`;
const RegisterContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 150px;
  background-color: rgb(38, 38, 38);
  border: white solid 0.5px;
  border-radius: 8px;
  aspect-ratio: 1/1;
  margin: 2.5rem 0 1rem 0;
`;
const Button = styled.button`
  width: 100px;
  margin-top: 0.7rem;
  padding: 0.3rem 0;
  color: white;
`;
const RegisterText = styled.p`
  margin: 0;
  padding: 0;
  /* font-size: smaller; */
`;
const Bold = styled.div`
  font-weight: 700;
  /* font-size: larger; */
`;
